import React, { Fragment, useContext, useState } from "react";
import { Button, Col, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { validateEmail } from "../../commonData";
import $ from "jquery";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";

const UserChangeEmail = (props) => {
    const { t } = useTranslation();
    const [account, setAccount] = useState({ oldEmail: props.email, newEmail: "", repeatEmail: "" });
    const { setAlerts, checkServerData } = useContext(BasicContext);
    const [blockForm, setBlockForm] = useState(false);
    const [changedForm, setChangedForm] = useState(false);

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (account.newEmail.length === 0 || !account.newEmail.replace(/\s+/, "")) {
            $("#accountnewEmail").addClass("is-invalid");
            errors.push(t("error.emptyEmail"));
        } else if (!validateEmail(account.newEmail)) {
            $("#accountnewEmail").addClass("is-invalid");
            errors.push(t("error.invalidEmail"));
        }

        if (account.repeatEmail.length === 0 || !account.repeatEmail.replace(/\s+/, "")) {
            $("#accountrepeatEmail").addClass("is-invalid");
            errors.push(t("error.emptyEmail"));
        } else if (!validateEmail(account.repeatEmail)) {
            $("#accountrepeatEmail").addClass("is-invalid");
            errors.push(t("error.invalidEmail"));
        }

        if (account.newEmail !== account.repeatEmail) {
            $("#accountnewEmail").addClass("is-invalid");
            $("#accountrepeatEmail").addClass("is-invalid");
            errors.push(t("error.emailsAreNotTheSame"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setBlockForm(true);
            setAlerts([{ variant: "info", message: t("info.changingEmail") }]);
            changeEmail();
        }
    };

    const changeEmail = async () => {
        const res = await postMethod("/user-change-email", { user: account });
        if (checkServerData(res)) {
            setChangedForm(false);
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "changedUserEmail" }]);
            const newEmail = account.newEmail;
            setAccount({ oldEmail: newEmail, newEmail: "", repeatEmail: "" });
            $(`#accountnewEmail`).removeClass("is-invalid");
            $(`#accountrepeatEmail`).removeClass("is-invalid");
        }
        setBlockForm(false);
    };

    const emails = ["newEmail", "repeatEmail"];

    return (
        <Fragment>
            <Col xs={12} className="px-4 px-lg-2 ">
                <p className="h5 mt-5 mb-2">{t("users.changeEmail")}</p>
                <p className="mb-3" style={{ fontSize: "0.875rem" }}>
                    {t("users.changeEmailTxt1")}
                    <strong>{props.email}</strong>. {t("users.changeEmailTxt2")}
                </p>
                <Form onSubmit={checkValidation} autoComplete="off">
                    {emails.map((e, i) => (
                        <Form.Group key={i} className="mb-3" controlId={`account${e}`}>
                            <Form.Label className="w-100">
                                {t(`users.${e}`)} <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                value={account[e]}
                                onChange={(el) => {
                                    setAccount({ ...account, [e]: el.target.value });
                                    setChangedForm(true);
                                    $(`#account${e}`).removeClass("is-invalid");
                                }}
                                onClick={props.onClick ? props.onClick : null}
                                placeholder={t(`users.${e}Placeholder`)}
                                type="email"
                                autoComplete="email"
                                disabled={blockForm}
                            />
                        </Form.Group>
                    ))}
                    <Form.Group>
                        <Button type="submit" disabled={blockForm || !changedForm}>
                            {t("saveChanges")}
                        </Button>
                    </Form.Group>
                </Form>
            </Col>
        </Fragment>
    );
};

export default UserChangeEmail;
